'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getFileFieldsOptions;

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function getFileFieldsOptions(fields) {
  return [{
    label: 'Select database field to assign',
    value: 'default',
    disabled: true
  }].concat(_toConsumableArray(fields.map(function (field) {
    return {
      label: field,
      value: field
    };
  })));
}